import client from "api/config";
import { convertNum } from "helper/convert-num";

const messagesUrl = "/admin/contact_us";
export const getUsersMessagesRequest = (values) =>
  client.get(messagesUrl, values);

export const getUsersMessageByIdRequest = (values) =>
  client.get(`${messagesUrl}/${values.id}`);

export const deleteUserMessageByIdRequest = (id) =>
  client.delete(`${messagesUrl}/${id}`);
